import { createContext, useState, useCallback, useMemo } from "react";
import { removeLocalStorage } from "../utils/helper";

export const UserContext = createContext({
  updateUserData: () => {},
  userLogout: () => {},
  userLogin: () => {},
  userData: "",
});

const UserContextProvider = ({ children }) => {
  const getSavedUser = () => {
    try {
      const info = JSON.parse(window.localStorage.getItem("userInfo"));
      const uid = window.localStorage.getItem("uid");
      const email = info?.email || uid || "";
      return {
        name: info?.name || "",
        email: email,
        isLoggedin: !!email,
        cart: [],
        ...(info || {}),
      };
    } catch (e) {
      return {
        name: "",
        email: "",
        isLoggedin: false,
        cart: [],
      };
    }
  };

  const initialValue = {
    name: "",
    email: "",
    isLoggedin: false,
    cart: [],
  };

  const [userData, setUserData] = useState(getSavedUser);

  const updateUserData = useCallback((data) => {
    setUserData((prev) => {
      return { ...prev, ...data };
    });
  }, []);

  const userLogin = useCallback(() => {}, []);

  const userLogout = useCallback(() => {
    removeLocalStorage("uid");
    removeLocalStorage("userInfo");
    setUserData(initialValue);
  }, []);

  const value = useMemo(
    () => ({ updateUserData, userData, userLogout, userLogin }),
    [updateUserData, userData, userLogout, userLogin]
  );

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;
